window.contentLoaded = false;

window.onload = function() {
    function loadContent(instagramFeedDiv) {
        let script = document.createElement('script');
        script.src = 'https://widget.reviews.io/modern-widgets/ugc.js';
        document.head.appendChild(script);
    }

    function addPreconnectLink(href) {
        let link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        document.head.appendChild(link);
    }

    setTimeout(() => {
        let observer = new MutationObserver(function(mutations) {
            let instagramFeedDiv = document.getElementById('reviews-io-ugc-widget');
            if(instagramFeedDiv) {
                window.addEventListener('scroll', () => {
                    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
                    const scrollPosition = window.scrollY;

                    if (!window.contentLoaded && scrollPosition / scrollHeight >= 0.5) {
                        window.contentLoaded = true;
                        addPreconnectLink('https://widget.reviews.io');
                        loadContent(instagramFeedDiv);
                    }
                });
                observer.disconnect();
            }
        });

        let config = {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        };

        observer.observe(document.body, config);
    }, 0);
}